module.exports = __webpack_public_path__ + "img/bg.5da189fc.png";